var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { uuidv4 } from '../../common/utils';
var AboutMe = function (_a) {
    var aboutMeInfos = _a.aboutMeInfos;
    return (_jsx(Container, { children: aboutMeInfos.map(function (_a) {
            var title = _a.title, titleColor = _a.titleColor, description = _a.description, descriptionColor = _a.descriptionColor;
            return (_jsxs(AboutMeEachContainer, { children: [_jsx(AboutMeTitle, __assign({ titleColor: titleColor }, { children: title })), _jsx(AboutMeDescription, __assign({ descriptionColor: descriptionColor }, { children: description }))] }, uuidv4()));
        }) }));
};
export default AboutMe;
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 10px 0px;\n"], ["\n  margin: 10px 0px;\n"])));
var AboutMeEachContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 10px 0px 10px 10px;\n"], ["\n  margin: 10px 0px 10px 10px;\n"])));
var AboutMeTitle = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-weight: bold;\n  color: ", ";\n"], ["\n  font-weight: bold;\n  color: ", ";\n"])), function (_a) {
    var titleColor = _a.titleColor;
    return titleColor;
});
var AboutMeDescription = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var descriptionColor = _a.descriptionColor;
    return descriptionColor;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
